export default __webpack_public_path__ + "img/see-icon.e0a723f9.svg";